import type React from 'react';

import type { TokenizationData } from 'src/app/shared/utils/payments';

import { SubmitButton } from './SubmitButton';

type Props = {
	disabled: boolean;
	loading: boolean;
	useDonationLanguage: boolean;
	onClick?: (paymentType: string, tokenizationData?: TokenizationData) => void;
};

export const DlocalButton: React.FC<Props> = ({ disabled, loading, useDonationLanguage, onClick }) => {
	function handleClick() {
		if (onClick) {
			onClick('dlocal');
		}
	}

	return (
		<SubmitButton
			disabled={disabled}
			loading={loading}
			useDonationLanguage={useDonationLanguage}
			onClick={handleClick}
		/>
	);
};
